<div class="appt-dialog" data-cy="appointment-edit-dialog">
  @if (isLoading) {
    <div class="spinner-container" data-cy="appointment-edit-spinner-container">
      <mat-spinner data-cy="appointment-edit-spinner"></mat-spinner>
    </div>
  }

  <div style="width: 100%; background-color: #00B5FB; display: flex; align-items: center;" data-cy="appointment-edit-header">
    <span style="flex: 1;">Edit Appointment</span>
    @if (!isNewAppoitment && data.appointment.enumApptStatusId !== '00000072-0000-0000-0000-000000000007') {
      <div (click)="onDeleteClick()" matTooltip="Delete appointment" style="cursor: pointer; padding: 2px 8px; color: white; display: flex; align-items: center;" data-cy="appointment-edit-delete-button">
        <lucide-icon name="trash-2" [size]="20"></lucide-icon>
      </div>
    }
  </div>

  <!--<lucide-icon name="home" [size]="20"></lucide-icon>-->

  <!--    normal appt view  *ngIf="!this.showBlockAppt()"-->
  @if (!this.showBlockAppt()) {
    <div class="section-content ui-dark-background" style="flex: 1; overflow-y: hidden; display: flex; height: 90%; flex-direction: column;" data-cy="appointment-edit-content">
      <div style="flex-basis: 188px; max-height: 188px; display: flex;" data-cy="appointment-edit-top-section">
        <div style="flex: 1; display: flex; flex-direction: column;" data-cy="appointment-edit-patient-section">
          <div style="font-weight: 500; color: var(--tdo-secondary); flex-basis: fit-content;" data-cy="appointment-edit-patient-label">Patient<span style="color: red;">*</span></div>
          @if (isNewAppoitment) {
            <div class="appointment-row" style="flex-basis: fit-content; max-height: 32px;" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null" data-cy="appointment-edit-patient-search-row">
              <div class="appointment-row-left" style="display: flex;" data-cy="appointment-edit-patient-search-label">
                <div style="margin-top: 1px; flex: 1; text-align: left; color: white; " data-cy="appointment-edit-find-patient-text">Find Patient</div>
                <div style="cursor: pointer; margin-top: 1px; margin-left: 5px;" data-cy="appointment-edit-patient-search-icon"><lucide-icon name="search" [size]="20"></lucide-icon></div>
              </div>
              <div class="appointment-row-right" style="padding-top: 0; display: flex;  " [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null" data-cy="appointment-edit-patient-search-input">
                <div style="flex: 1; max-height: 20px; margin-top: 6px; overflow-y: hidden;" data-cy="appointment-edit-patient-search-container">
                  <tdo-patient-search #searchInput [isChangeUser]="false" (patientSelect)="onPatientSearchSelectionChanged($event);" [displayWith]="displayFn" [disabled]="false" data-cy="appointment-edit-patient-search"></tdo-patient-search>
                </div>
                <div (click)="onNewPatientClick()" style="color: var(--tdo-primary-accent); flex-basis: fit-content; cursor: pointer; margin-top: 4px;" matTooltip="Add new patient" data-cy="appointment-edit-add-patient-button"><lucide-icon name="user-plus" [size]="20"></lucide-icon></div>
              </div>
            </div>
          }
          @if (data.appointment.PatientName) {
            <div  data-cy="appointment-edit-patient-info">
              <table style="width: 100%;">
                <tr>
                  <td style="width: 15%;">Patient:</td>
                  <td style="width: 55%; ">
                    <div matTooltip="Edit patient" (click)="launchPatientDetails()" style=" cursor: pointer;   font-size: large; color: var(--tdo-secondary); font-weight: 500; overflow-y: hidden;" data-cy="appointment-edit-patient-name">
                      <div >{{data.appointment.PatientName}}</div>
                    </div>
                  </td>
                  <td rowspan="3" align="center" style="width: 30%; ">
                    <div  data-cy="appointment-edit-patient-image">
                      <img [src]="patientPictureSrc | secureImage | async" style="border-radius: var(--border-radius); height: 66px; margin-right: 2px;" data-cy="appointment-edit-patient-picture" />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;">Phone:</td>
                  <td style="width: 60%;">
                    @if (getPatientPhoneNumber() !== '') {
                      <span  >{{getPatientPhoneNumber() | formatPhone}}</span>
                    }
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td style="width: 10%;">Balance:</td>
                  <td style="width: 60%;">
                    <div style="cursor: pointer;" (click)="gotoPatientLedger()" data-cy="appointment-edit-balance-value">${{patient?.BalanceDue ? patient.BalanceDue : '0'}}</div>
                  </td>
                  <td></td>
                </tr>
              </table>
  </div>
}
<div class="appointment-row" style="flex-basis: fit-content;" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null" data-cy="appointment-edit-referring-doctor-row">
  <div class="appointment-row-left" style="display: flex; " data-cy="appointment-edit-referring-doctor-label">
    <div style="flex: 1;" data-cy="appointment-edit-referring-doctor-text">Referring Doctor <span style="color: red;">*</span></div>
    <div matTooltip="Clear Referring Doctor" (click)="clearReferring()" style="flex-basis: fit-content;cursor: pointer;" data-cy="appointment-edit-clear-referring-button"><lucide-icon name="x" [size]="20"></lucide-icon></div>
  </div>
  <div class="appointment-row-right" style="height: 32px;" data-cy="appointment-edit-referring-doctor-input">
    <div style="margin-top: 0px; margin-left: -5px; display: flex; align-items: center; gap: 10px;" data-cy="appointment-edit-referring-doctor-dropdown">
      <!-- <tdo-dropdown-v2 *ngIf="referringDoctors && referringDoctors.length > 0" [datasource]="referringDoctors" [displayPredicate]="referringDoctorPredicate" [value]="getReferringDoctor()" isHideUnderline="true" (selectionChange)="onReferringDoctorChange($event)" placeholder="" data-cy="appointment-edit-referring-doctor-select"></tdo-dropdown-v2> -->
      
      <dx-select-box style="height: 32px; flex: 1;"
        [inputAttr]="{ placeholder: '' }"
        [dataSource]="selectDoctorBoxDataSource"
        [searchEnabled]="true"
        [searchExpr]="['Fullname']"
        displayExpr="Fullname"
        valueExpr="DoctorId"
        [(value)]="Referring_DoctorId"
        placeholder="Search for Doctor ..."
        [dropDownOptions]="dropDownOptions"
        (onValueChanged)="onReferringDoctorValueChanged($event)"
        data-cy="appointment-edit-referring-doctor-dropdown"        
        [inputAttr]="{ 'data-cy': 'appointment-edit-referring-doctor-dropdown-input' }"
        >
      </dx-select-box>

      <dx-button icon="add"  hint="Add New Doctor" (onClick)="onNewDoctorClickHandler($event)"></dx-button>
    </div>
  </div>
</div>
</div>
<div style="flex-basis: 20px;"></div>
<div style="flex: 1;" data-cy="appointment-edit-schedule-section">
  <div style="font-weight: 500; color: var(--tdo-secondary); flex-basis: fit-content;" data-cy="appointment-edit-schedule-label">Schedule</div>
  <div class="appointment-row" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null" data-cy="appointment-edit-date-row">
    <div class="appointment-row-left" data-cy="appointment-edit-date-label">Date<span style="color: red;">*</span></div>
    <div class="appointment-row-right" data-cy="appointment-edit-date-input">
      <input type="date" [(ngModel)]="sLocalStartDate" style="width: 100%;" />
    </div>
  </div>
  <div class="appointment-row" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null" data-cy="appointment-edit-time-row">
    <div class="appointment-row-left" data-cy="appointment-edit-start-label">Start<span style="color: red;">*</span></div>
    <div class="appointment-row-right" data-cy="appointment-edit-start-input"><tdo-time-input [interval]="data.timeIncrement" widthString="100%" style="position: relative;" [value]="localStartTime" (dateChanged)="onStartDateChange($event)" data-cy="appointment-date-start"></tdo-time-input></div>
    <div style="flex-basis: 2px; min-width: 2px;"></div>
    <div class="appointment-row-left" data-cy="appointment-edit-end-label">End<span style="color: red;">*</span></div>
    <div class="appointment-row-right" data-cy="appointment-edit-end-input"><tdo-time-input [interval]="data.timeIncrement" widthString="100%" style="position: relative;" [value]="localEndTime" (dateChanged)="onEndDateChange($event)" data-cy="appointment-date-end"></tdo-time-input></div>
  </div>
  <div class="appointment-row" style="margin-top: 10px;" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null" data-cy="appointment-edit-type-row">
    <div class="appointment-row-left" data-cy="appointment-edit-type-label">Type </div>
    <div class="appointment-row-right" style="padding-top: 0;" data-cy="appointment-edit-type-input">
      <div data-cy="appointment-edit-type-select">
        <!-- <app-tdo-enum-select zVersion="Z1" name="enumApptType" [isHideUnderline]="true" [validValueItemId]="data.appointment?.enumApptTypeId" (enumSelected)="onAppointmentTypeChange($event)" data-cy="appointment-edit-type-enum"></app-tdo-enum-select> -->
        <app-tdo-enum-select zVersion="Z1" name="enumApptType" [isHideUnderline]="true" [validValueItemId]="data.appointment?.enumApptTypeId" (selectionChange)="onAppointmentTypeChange($event)" [enableToggleClose]="true" data-cy="appointment-edit-type-enum"></app-tdo-enum-select>
      </div>
    </div>
  </div>
  <div class="appointment-row" style="margin-top: 10px;" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null" data-cy="appointment-edit-status-row">
    <div class="appointment-row-left" data-cy="appointment-edit-status-label">Status</div>
    <div class="appointment-row-right" style="padding-top: 0;" data-cy="appointment-edit-status-input">
      <div data-cy="appointment-edit-status-select">
        <!-- <app-tdo-enum-select zVersion="Z1" name="enumApptStatus" [isHideUnderline]="true" [validValueItemId]="data.appointment?.enumApptStatusId" (enumSelected)="data.appointment.enumApptStatusId = $event.ValidValueItemId" data-cy="appointment-edit-status-enum"></app-tdo-enum-select></div> -->
        <app-tdo-enum-select zVersion="Z1" name="enumApptStatus" [isHideUnderline]="true" [excludeItemIds]="excludedApptStatusIds" [validValueItemId]="data.appointment?.enumApptStatusId" (selectionChange)="onAppointmentStatusChange($event)" [enableToggleClose]="true" data-cy="appointment-edit-status-enum"></app-tdo-enum-select></div>
      </div>
    </div>
  </div>
</div>
<div style="display: flex;">
  <div style="flex: 1;">
    <div style="font-weight: 500; color: var(--tdo-secondary); flex-basis: fit-content;">Description</div>
    <div class="appointment-row" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null">
      <div class="appointment-row-left" style="display: flex;"><div style="flex: 1; text-align: right;">Teeth/Subject</div><div style="flex-basis: fit-content;"><img (click)="selectAppointmentTooth()" matTooltip="Select tooth / teeth" style="width: 20px; height: 20px; position: relative; top: -2px; cursor: pointer;" src="assets/Images/Calendar/iconToothNew.svg"></div></div>
      <div class="appointment-row-right" style="padding-top: 0;">
        <!--            <tdo-input type="text" [value]="data?.appointment?.Subject" (inputFinished)="data.appointment.Subject = $event" [isHideUnderline]="true"></tdo-input>-->
        <input type="text"  style="height: 28px; width: 100% ; border-color: transparent"  [(ngModel)]="data.appointment.Subject" />
      </div>
    </div>
    <div class="appointment-row" [class]="isAppointmentDoNotAllowEditNotes ? 'edit-disabled' : null">
      <div class="appointment-row-left">Appt. Note</div>
      <div class="appointment-row-right" style="padding-top: 0;">
        <!--            <tdo-input type="text" [value]="data?.appointment?.Description" (inputFinished)="data.appointment.Description = $event" [isHideUnderline]="true"></tdo-input>-->
        <input type="text" style="height: 28px; width: 100% ; border-color: transparent"  [(ngModel)]="data.appointment.Description" />
      </div>
    </div>
    <div class="appointment-row" style="height: 90px;" [class]="isAppointmentDoNotAllowEditNotes ? 'edit-disabled' : null">
      <div class="appointment-row-left">Patient Note</div>
      <div class="appointment-row-right" style="padding-top: 0; max-height: 200px; overflow-y: hidden;">
        <app-tdo-simple-note [isHideBorder]="true" [height]="'100%'" [disabled]="data.appointment && !data.appointment.PatientId"
          #simpleNote [PatientId]="data.appointment.PatientId"
          parentObjectName="dataAppointment"
          [objectId]="data.appointment.AppointmentId ==undefined ? 'NEWAPPT' : data.appointment.AppointmentId "
          categoryEnumId="00000018-1000-0000-0000-000000000039"
          typeEnumId="00000019-1000-0000-0000-000000000001"
        ></app-tdo-simple-note>
      </div>
    </div>
    <div style="flex: 1; display: flex;" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null">
      <!--PATIENT FLAGS-->
      @for (flag of data.appointment.PatientFlagsEnums; track flag) {
        <img style="height: 20px; width: 20px; position: relative;" [src]="getPatientFlagImage(flag)" [matTooltip]="getPatientFlagTooltip(flag)" />
      }
    </div>
  </div>
  <div style="flex-basis: 20px;"></div>
  <div style="flex: 1;">
    <div style="font-weight: 500; color: var(--tdo-secondary); flex-basis: fit-content;">What are we doing?</div>
    <div class="appointment-row" [class]="isAppointmentDoNotAllowEdit  ? 'edit-disabled' : null">
      <!-- <div class="appointment-row" [class]="isAppointmentDoNotAllowEdit || isAppoitmentDoNotAllowProcEdit ? 'edit-disabled' : null"> -->
      <div (click)="onProcedureClick()" data-cy="edit-appointment-dialog-procedure-header" class="appointment-row-left" style="display: flex;"><div style="flex: 1; cursor: pointer;">Procedure<span style="color: red;">*</span></div><div style="flex-basis: 2px;"></div><div style="color: white;"><lucide-icon name="stethoscope" [size]="20" matTooltip="Add procedure"></lucide-icon></div></div>
      <div (click)="onProcedureClick()" data-cy="edit-appointment-dialog-procedure-value" style="cursor: pointer; padding-top: 0;" class="appointment-row-right">{{procedureName}}</div>
    </div>
    <div style="display: flex;" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null">
      <div style="margin-right: 6px; margin-top: 5px;">By scheduled provider/doctor:</div>
      <div style="flex: 1;"><mat-checkbox data-cy="edit-appointment-dialog-all-doctors-checkbox" style="margin-top: 5px; float:right;" [checked]="isAllDoctors" (change)="onAllDoctorsChange($event)">Show all providers/doctors</mat-checkbox></div>
    </div>
    <div class="appointment-row" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null">
      <div class="appointment-row-left" data-cy="edit-appointment-dialog-provider-doctor-header">Provider/Doctor<span style="color: red;">*</span></div>
      <div class="appointment-row-right" style="padding-top: 0;">
        <div style="margin-top: -5px;">
          @if (providerDoctors && providerDoctors.length > 0) {
            <tdo-dropdown-v2 data-cy="edit-appointment-dialog-provider-doctor-dropdown" [datasource]="providerDoctors" [displayPredicate]="doctorPredicate" [isMultiSelect]="false" [value]="getProviderDoctor()" [disabledPredicate]="doctorDisabledPredicate" (selectionChange)="onProviderDoctorChange($event)" isHideUnderline="true" [enableToggleClose]="true"></tdo-dropdown-v2>
          }
        </div>
      </div>
    </div>
    <div class="appointment-row" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null">
      <div class="appointment-row-left">Operatory</div>
      <div class="appointment-row-right" style="padding-top: 0;">
        <div style="margin-top: -5px;">
          <tdo-dropdown-v2 displayProperty="LocAndOpName" [datasource]="this.data.operatories" [value]="getOperatory()" (selectionChange)="onOperatoryChange($event)" isHideUnderline="true" [enableToggleClose]="true"></tdo-dropdown-v2>
        </div>
      </div>
    </div>
    <div class="appointment-row" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null">
      <div class="appointment-row-left">Additional ops</div>
      <div class="appointment-row-right" style="padding-top: 0;">
        <div style="margin-top: -5px;">
          <tdo-dropdown-v2 (selectionChange)="onSecondaryOperatoryChange($event)" [isMultiSelect]="true" displayProperty="LocAndOpName" [datasource]="getAdditionalOpsList()" isHideUnderline="true" [value]="getSecondOperatories()" (closed)="onSecondOperatoryClosed($event)" [enableToggleClose]="true"></tdo-dropdown-v2>
        </div>
      </div>
    </div>
  </div>
</div>
<div style="display: flex; gap: 20px;">
  <div style="flex: 1;">
    <!-- Left column content -->
    @if (data.appointment?.enumApptStatusId !== '00000072-0000-0000-0000-000000000007') {
      <div style="padding: 10px; " >
        <!-- <h4>Left Column regular MISC</h4>
        <p>Content for the left column goes here.</p> -->
        <div style="flex: 1; display: flex;"   >
          <div style="flex: 3;">
            <mat-checkbox [checked]="checkDetailBool('needToConfirmApp')" (change)="onDetailChange($event, 'needToConfirmApp')" style="height: 10px;">Need to call to confirm appointment</mat-checkbox><br />
            <mat-checkbox [checked]="checkDetailBool('calledLeftMsg')" (change)="onDetailChange($event, 'calledLeftMsg')" style="height: 10px;">Called and left message</mat-checkbox><br />
            <mat-checkbox [checked]="checkDetailBool('earlierAppIfPossible')" (change)="onDetailChange($event, 'earlierAppIfPossible'); onDetailChange($event, 'isAddToWaitList'); onEarlierAppointment($event)" style="height: 10px;">Would like an earlier appointment if possible</mat-checkbox><br />
            @if (this.isWaitList===true) {
              <textarea   rows="3" [value]="WaitListReason" (appInputFinished)="onEarlierAppointmentReason($event)"  style="resize: none; height: 36px; width: 300px; line-height: 1.0; font-size: 12px;"></textarea>
            }
          </div>
          <div style="flex: 2; margin-left: 6px;">
            <mat-checkbox   [checked]="checkDetailBool('needPremed')" (change)="onDetailChange($event, 'needPremed')" style="height: 10px;">Need premedication</mat-checkbox><br />
            <mat-checkbox  [checked]="checkDetailBool('sendSMS')" (change)="onDetailChange($event, 'sendSMS')" style="height: 10px;">Send SMS</mat-checkbox><br />
            <mat-checkbox  [checked]="checkDetailBool('sendEmail')" (change)="onDetailChange($event, 'sendEmail')" style="height: 10px;">Send Email</mat-checkbox><br />
          </div>
        </div>
      </div>
    }
    @if (data.appointment?.enumApptStatusId === '00000072-0000-0000-0000-000000000007'  ) {
      <div style="padding: 10px; " >
        <!-- <h4>Left Column regular Cancel</h4>
        <p>Content for the left column goes here.</p> -->
        <div style="flex: 1; display: flex;" >
          <div style="flex: 2;">
            <mat-checkbox #addToCallListCheck id="addToCallListCheck" [checked]="checkDetailValueBool('isAddToCallList')" (change)="onDetailValueChange($event.checked, willCallDateTime.value,'isAddToCallList')" style="height: 10px;">Add to Call List</mat-checkbox><br />
            <mat-checkbox #patientCallCheck id="patientCallCheck" [checked]="checkDetailBool('isPatientWillCall')" (change)="onDetailChange($event, 'isPatientWillCall')" style="height: 10px;">Patient Will Call</mat-checkbox><br />
          </div>
          <div style="flex: 1;">
            <div  style="position: relative; height: 32px; margin-right: 2px;">
              <app-tdo-enum-select zVersion="Z1" name="enumNextApptWhen" placeholder="When to call" [isHideUnderline]="false" hidesingleSelectionIndicator="true"
                (enumSelected)="onCancellationCallTaskChange($event, addToCallListCheck, willCallDateTime)"
                [validValueItemId]="this.NextApptWhenEnum.THIRTY_DAYS">
              </app-tdo-enum-select>
            </div>
          </div>
          <div style="flex: 1; margin-left: 20px;">
            <mat-form-field style="width: 100%; position: relative; top: -10px">
              <input #willCallDateTime style="font-size: 12px; width: 100%; margin-bottom: 10px;"
                (blur)="onDetailValueChange(true, willCallDateTime.value, 'isAddToCallList')" matInput type="datetime-local"
                placeholder="Call date / time">
              </mat-form-field>
            </div>
          </div>
        </div>
      }
    </div>
    <div style="flex: 1;">
      <!-- Right column content -->
      <div >
        <div style="flex-basis: 20px;"></div>
        <div style="flex: 1;">
          <!-- <div class="appointment-row" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null">
          <div class="appointment-row-left">Appointment By</div>
          <div class="appointment-row-right" style="padding-top: 0;">
            <div style="margin-top:1 -5px;">
            </div>
          </div>
        </div> -->
        <mat-checkbox [checked]="isOverrideSms" (change)="onOverrideSmsMessage($event)"  [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null">Override SMS Message</mat-checkbox><br />
        @if (isOverrideSms) {
          <div style="width: 100%; height: 36px; border: 1px solid var(--tdo-primary); border-radius: 6px; padding: 0 3px 0 3px; overflow-y: hidden;">
            <textarea [value]="customSmsMessage" rows="3" (appInputFinished)="onCustomSmsFinished($event)" style="resize: none; overflow-y: auto; outline: unset; border: unset; padding: 2px; height: 100%; width: 100%; line-height: 1.1; font-size: 12px;"></textarea>
          </div>
        }
        <div style="display: flex; opacity: 0.6;">
          <div style="flex: 1; display: flex; font-size: 12px;">
            <div style="flex-basis: 94px; text-align: right;">Last modified by:</div>
            <div style="flex: 1; margin-left: 4px;">{{getUser(data.appointment?.xauditModifiedBy)}}</div>
          </div>
          <div style="flex: 1; display: flex; font-size: 12px;">
            <div style="flex-basis: 94px; text-align: right;">Last modified on:</div>
            <div style="flex: 1; margin-left: 4px;">{{data.appointment.xauditModifiedOn | date: 'shortDate'}}</div>
          </div>
        </div>
        <div style="display: flex; opacity: 0.6;">
          <div style="flex: 1; display: flex; font-size: 12px;">
            <div style="flex-basis: 94px; text-align: right;">Taken by:</div>
            <div style="flex: 1; margin-left: 4px;">{{getUser(data.appointment?.xauditCreatedBy)}}</div>
          </div>
          <div style="flex: 1; display: flex; font-size: 12px;">
            <div style="flex-basis: 94px; text-align: right;">Taken on:</div>
            <div style="flex: 1; margin-left: 4px;">{{data.appointment.xauditCreatedOn | date: 'shortDate'}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div style="flex: 1; overflow-y: auto; display: flex; flex-direction: column;">
  <div style="font-weight: 500; color: var(--tdo-secondary); margin-top: 10px; flex-basis: fit-content;">Appointment History</div>
  <div style="flex: 1; height: 200px; overflow-y: auto;" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null">
    <tdo-table #appointmentTable [dataSource]="patientAppointments" [isSearchable]="false" >
      <tdo-table-column displayName="Date" propertyName="StartDate" [rowTemplate]="date">
        <ng-template let-row #date>{{row.model.startDate | date: 'shortDate'}}</ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Start Time" propertyName="StartDateTime" [rowTemplate]="dateT">
        <ng-template let-row #dateT>{{row.model.startDate | date: 'hh:mm a'}}</ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Day" propertyName="StartDateT" [rowTemplate]="date1">
        <ng-template let-row #date1>{{row.model.startDate | date: 'EEEE'}}</ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Teeth / Subject" propertyName="Subject" [rowTemplate]="subject">
        <ng-template let-row #subject>
          <div style="min-width: 200px;">{{row.model.Subject}}</div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="For Procedure" propertyName="procedure" [rowTemplate]="type1">
        <ng-template let-row #type1>{{row.model.ApptReasonDescription}} - {{row.model.ForProcedure}}</ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Status" propertyName="ApptStatus" [rowTemplate]="typeS">
        <ng-template let-row #typeS>{{row.model.ApptStatus}}</ng-template>
      </tdo-table-column>
    </tdo-table>
  </div>
</div>
</div>
}


<!--    blocked appt view-->
@if (this.showBlockAppt()) {
  <div style="display: flex; margin: 10px;"  >
    <div style="float:left; width: 50%;margin-right: 10px">
      <div style="font-weight: 500; color: var(--tdo-secondary); flex-basis: fit-content;">Blocked Time Period</div>
      <div class="appointment-row" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null">
        <div class="appointment-row-left" style="display: flex;"><div style="flex: 1; text-align: right;">Name</div><div style="flex-basis: fit-content;">
          <!-- <img (click)="selectAppointmentTooth()" matTooltip="Select tooth / teeth" style="width: 20px; height: 20px; position: relative; top: -2px; cursor: pointer;" src="assets/Images/Calendar/iconToothNew.svg"> -->
        </div></div>
        <div class="appointment-row-right" style="padding-top: 0;">
          <!-- <tdo-input type="text" [value]="data?.appointment?.Subject" (inputFinished)="data.appointment.Subject = $event" [isHideUnderline]="true"></tdo-input> -->
          <input type="text"  style="height: 28px; width: 100% ; border-color: transparent"  [(ngModel)]="data.appointment.Subject" />
        </div>
      </div>
      <div class="appointment-row" [class]="isAppointmentDoNotAllowEditNotes ? 'edit-disabled' : null">
        <div class="appointment-row-left">Comment</div>
        <div class="appointment-row-right" style="padding-top: 0;">
          <!-- <tdo-input type="text" [value]="data?.appointment?.Description" (inputFinished)="data.appointment.Description = $event" [isHideUnderline]="true"></tdo-input> -->
          <input type="text" style="height: 28px; width: 100% ; border-color: transparent"  [(ngModel)]="data.appointment.Description" />
        </div>
      </div>
      <div class="appointment-row" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null" style="margin-top: 10px">
        <div class="appointment-row-left">Operatory</div>
        <div class="appointment-row-right" style="padding-top: 0;">
          <div style="margin-top: -5px;">
            <tdo-dropdown-v2 displayProperty="OperatoryName" [datasource]="this.data.operatories" [value]="getOperatory()" (selectionChange)="onOperatoryChange($event)" isHideUnderline="true" [enableToggleClose]="true"></tdo-dropdown-v2>
          </div>
        </div>
      </div>
      <div class="appointment-row" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null" style="margin-top: 10px">
        <div class="appointment-row-left">Additional ops</div>
        <div class="appointment-row-right" style="padding-top: 0;">
          <div style="margin-top: -5px;">
            <tdo-dropdown-v2 (selectionChange)="onSecondaryOperatoryChange($event)" [isMultiSelect]="true" displayProperty="OperatoryName" [datasource]="getAdditionalOpsList()" isHideUnderline="true" [value]="getSecondOperatories()" (closed)="onSecondOperatoryClosed($event)" [enableToggleClose]="true"></tdo-dropdown-v2>
          </div>
        </div>
      </div>
    </div>
    <div style="float:right; width: 50%">
      <div style="font-weight: 500; color: var(--tdo-secondary); flex-basis: fit-content;">Schedule</div>
      <div class="appointment-row" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null">
        <div class="appointment-row-left">Date</div>
        <div class="appointment-row-right">
          <input type="date" [(ngModel)]="sLocalStartDate" style="width: 100%;" />
        </div>
      </div>
      <div class="appointment-row" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null">
        <div class="appointment-row-left">Start</div>
        <div class="appointment-row-right"><tdo-time-input [interval]="data.timeIncrement" widthString="100%" style="position: relative;" [value]="localStartTime" (dateChanged)="onStartDateChange($event)"></tdo-time-input></div>
        <div style="flex-basis: 2px; min-width: 2px;"></div>
        <div class="appointment-row-left">End</div>
        <div class="appointment-row-right"><tdo-time-input [interval]="data.timeIncrement" widthString="100%" style="position: relative;" [value]="localEndTime" (dateChanged)="onEndDateChange($event)"></tdo-time-input></div>
      </div>
      <div class="appointment-row" style="margin-top: 10px;" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null">
        <div class="appointment-row-left">Type </div>
        <div class="appointment-row-right" style="padding-top: 0;">
          <div >
            <!-- <app-tdo-enum-select style="position: relative; top: 5px;" name="enumApptType" [isHideUnderline]="true" [validValueItemId]="data.appointment?.enumApptTypeId" (enumSelected)="data.appointment.enumApptTypeId = $event.ValidValueItemId"></app-tdo-enum-select>   -->
            <app-tdo-enum-select zVersion="Z1"  name="enumApptType" [isHideUnderline]="true" [validValueItemId]="data.appointment?.enumApptTypeId" (enumSelected)="onAppointmentTypeChange($event)"></app-tdo-enum-select>
          </div>
        </div>
      </div>
      <div class="appointment-row" style="margin-top: 10px;" [class]="isAppointmentDoNotAllowEdit ? 'edit-disabled' : null">
        <div class="appointment-row-left">Status</div>
        <div class="appointment-row-right" style="padding-top: 0;">
          <div >
            <app-tdo-enum-select   zVersion="Z1"   name="enumApptStatus" [isHideUnderline]="true" [excludeItemIds]="excludedApptStatusIds" [validValueItemId]="data.appointment?.enumApptStatusId" (enumSelected)="data.appointment.enumApptStatusId = $event.ValidValueItemId"></app-tdo-enum-select></div>
          </div>
        </div>
      </div>
    </div>
  }



  <div style="float: right">
    <button mat-raised-button color="primary" (click)="onSaveClick()" [disabled]="isSaving">{{ isSaving ? 'Saving...' : 'Save' }}</button>
    <button mat-raised-button color="primary" (click)="onCancelClick()" >Cancel</button>
  </div>




</div>


<dx-popup
  [visible]="isNewDoctorPopupVisible"
  [width]="400"
  [height]="300"
  [title]="'Add New Doctor'"
  (onHidden)="onNewDoctorPopupHidden($event)"
  >

  <div *dxTemplate="let data of 'content'">
    <dx-text-box [(ngModel)]="newDoctorFirstName" placeholder="First Name"></dx-text-box>
    <dx-text-box [(ngModel)]="newDoctorLastName" placeholder="Last Name"></dx-text-box>

    <div style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px;">
      <dx-button text="Save" (onClick)="onNewDoctorSave($event)"></dx-button>
      <dx-button text="Cancel" (onClick)="onNewDoctorPopupHidden($event)"></dx-button>
    </div>

  </div>




</dx-popup>

